import { z } from 'zod';
import { guardExhaustive } from 'libs/end-to-end/src/generic';

export const ObservationLocationDBRevisionType = z.object({
  type: z.literal('db-revision'),
  databaseId: z.string().min(1),
  databaseRevisionId: z.string().min(1),
});

export const ObservationLocationType = ObservationLocationDBRevisionType;

export type ObservationLocationType = z.infer<typeof ObservationLocationType>;

export const generateQueryPartOnObservation = (
  observation: ObservationLocationType,
) => {
  if (observation.type === 'db-revision') {
    return `databaseRevisionId=${encodeURIComponent(
      observation.databaseRevisionId,
    )}&databaseId=${encodeURIComponent(observation.databaseId)}`;
  }

  throw guardExhaustive(observation.type);
};
